.searchBar {
    margin-bottom: 15px;
    gap: 10px;
    width: 100%;
}

.search {
    min-width: 150px;
    flex: 1;
    font-size: 14px;
    font-family: Hanken Grotesk;
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    
    &:focus {
        outline: none;
        border-color: #0066FF;
    }
}

.industrySearch {
    min-width: 200px;
    flex: 2;
    
    & * {
        font-size: 14px !important;
        font-family: Hanken Grotesk !important;
        border-radius: 6px !important;
        margin: 0 !important;
    }

    & *[class*='btn-close'] {
        box-shadow: none !important;
    }

    & *[class*='rbt-input-multi'] {
        padding: 4px !important;
    }

    & *[class*='rbt-input-main'] {
        padding: 8px !important;
    }

    & *[class*='rbt-input-wrapper'] {
        min-height: 38px !important;
        display: flex !important;
        align-items: center !important;
        flex-wrap: wrap !important;
        gap: 4px !important;
    }

    & *[class*='rbt-token'] {
        font-size: 12px !important;
        font-family: Hanken Grotesk !important;
        height: 28px !important;
        display: inline-flex !important;
        align-items: center !important;
        margin: 2px !important;
        padding: 0 8px !important;
        position: relative !important;
        
        &:not(:first-child) {
            margin-left: 4px !important;
        }
    }

    & *[class*='rbt-token-remove-button'] {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
        margin-left: 6px !important;
        transform: scale(1.2);
        position: relative !important;
        top: -1px !important;
    }
} 